import $ from 'jquery';

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */
const toggleMenu = (event) => {
  event.preventDefault();
  $('.js-menu-toggle, .nav--header').toggleClass('open');
  $('.header').toggleClass('menu-open');
  $('html, body').toggleClass('menu-open-stop-scrolling');
    $( "#menu-search-button" ).removeClass('search-close');
  $( ".search-bar" ).removeClass('search-open');
};
const toggleSearch = (event) => {
    event.preventDefault();
    $( "#menu-search-button" ).toggleClass('search-close');
    $( ".search-bar" ).toggleClass('search-open');
    $('.js-menu-toggle, .nav--header').removeClass('open');
    $('.header').removeClass('menu-open');
    $('html, body').removeClass('menu-open-stop-scrolling');
};
// Toggle Menu
$('.js-menu-toggle').on('click', toggleMenu);
//Toggle Search
$('#menu-search-button').on('click', toggleSearch);

$(document).ready(function($) {
  $('.video-overlay').click(function(){
    $('.video-overlay').hide();
    $('.video-container').show();
  });
  $('.approve_terms').click(function(){
    setCookie('icgf_terms',1,1);
    $('.terms-overlay').hide();
    $('html, body').removeClass('menu-open-stop-scrolling');
  });
    $('#accordion').find('.question').click(function(){
      $(this).toggleClass('open');
      //Expand or collapse this panel
      $(this).next().slideToggle('fast');
      //Hide the other panels
    });
    $('.documents').find('.expanding-header').click(function(){
      $(this).toggleClass('open');
      //Expand or collapse this panel
      $(this).next().slideToggle('fast');
      //Hide the other panels
    });
  });

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

